export default __webpack_public_path__ + "img/74a37b7db47f1bc081ebd7ed1fdfdf05.png";